import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

import { Message } from "@/domains/messages/components";
import type { MessageDataModel } from "@/domains/messages/models/types";
import { ProgressEntryLink } from "@/domains/progress/components";
import { useIsProgressEnabled } from "@/domains/progress/hooks/use-is-progress-enabled";
import { Divider, Heading } from "@/ui";

const yourCareplanHeaderVariants = tv({
  base: "flex flex-col gap-8",
});

type YourCareplanHeaderProps = {
  title: string;
  latestMessage: {
    message?: MessageDataModel;
    truncate: boolean;
  };
} & ComponentProps<"div">;

export const YourCareplanHeader = ({
  className,
  latestMessage,
  title,
}: YourCareplanHeaderProps) => {
  const isProgressEnabled = useIsProgressEnabled();
  const showToggle = latestMessage.truncate && latestMessage.message?.exceedsTruncateLength;

  return (
    <div className={yourCareplanHeaderVariants({ className })}>
      <div className="flex flex-col gap-3">
        <Heading level={1}>{title}</Heading>

        {isProgressEnabled ? <ProgressEntryLink /> : null}
      </div>

      <Divider.Line />

      {latestMessage.message ? (
        <Message.Root
          className="items-start"
          message={latestMessage.message}
          truncate={latestMessage.truncate}
        >
          <Message.Avatar />
          <div className="flex flex-col gap-8">
            <Message.Bubble arrow={false} className="max-w-none bg-transparent p-0 shadow-none" />
            {showToggle ? <Message.Toggle /> : null}
          </div>
        </Message.Root>
      ) : null}
    </div>
  );
};
